import { useState } from 'react';
import { dsClass } from '../../../common/constants/dsClasses.js';
import { t } from '../../../common/i18n/index.js';
import { formatPhoneNumber } from '../../../common/utils/phoneNumberUtils.js';
import { GutterStyle, SelectOneList, type SelectOneListItemProps } from '../../SelectOneList/index.js';
import { ShowMoreButton } from './ShowMoreButton.js';
import type { NumberRange } from '../../../generated/api/numberRange.js';

export const CorporateNumberRangeSelect = ({
  currentPbxSolutionNumberRanges,
  onSelect,
  selectedValue,
}: {
  currentPbxSolutionNumberRanges: NumberRange[];
  onSelect: (value: string) => void;
  selectedValue?: string;
}) => {
  const [amountOfRangesShown, setAmountOfRangesShown] = useState(8);

  const getOption = (numberRange: NumberRange): SelectOneListItemProps => ({
    element: (
      <div className="of-attach-pbx-content__selection of-select-number-list">
        <div className="of-attach-pbx-content__number-range-row">{`${formatPhoneNumber(
          numberRange.startNumber,
          true
        )} – `}</div>
        <div className="of-attach-pbx-content__number-range-row">{`${formatPhoneNumber(
          numberRange.endNumber,
          true
        )}`}</div>
      </div>
    ),
    isSelected: selectedValue === numberRange.rangeId,
    onClick: () => onSelect(numberRange.rangeId),
  });

  return (
    <div id="subscription-company-number-space" className={dsClass.MARGIN_TOP_4}>
      <div className={dsClass.FONT_SIZE_LARGE}>{t.H094('Corporate numbering space')}:</div>
      <SelectOneList
        disableIcon={true}
        gutterStyle={GutterStyle.Minimal}
        maxItemsAsideDesktop={4}
        maxItemsAsideLaptop={4}
        maxItemsAsideTablet={3}
        options={currentPbxSolutionNumberRanges
          .slice(0, amountOfRangesShown)
          .map(numberRange => getOption(numberRange))}
      />
      {amountOfRangesShown < currentPbxSolutionNumberRanges.length && (
        <ShowMoreButton onClick={() => setAmountOfRangesShown(amountOfRangesShown + 4)} />
      )}
    </div>
  );
};
